import { render, staticRenderFns } from "./List.vue?vue&type=template&id=527a75fa&scoped=true&"
import script from "../js/list.js?vue&type=script&lang=js&"
export * from "../js/list.js?vue&type=script&lang=js&"
import style0 from "../styles/list.sass?vue&type=style&index=0&id=527a75fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a75fa",
  null
  
)

export default component.exports